<template>
  <v-container>
    <Head title="Kebijakan Privasi" />
    <v-container
      class="text-center"
      :class="[
        sectionClass,
        {
          'my-8': !$vuetify.breakpoint.mobile,
        },
      ]"
    >
      <p
        class="font-weight-bold"
        :class="[$vuetify.breakpoint.mobile ? 'text-h4' : 'text-h2']"
      >
        Kebijakan Privasi
      </p>
    </v-container>
    <v-container :class="sectionClass">
      <h2 class="primary--text">KETENTUAN DAN KEBIJAKAN PRIVASI</h2>
      <p>
        Adanya Kebijakan Privasi ini adalah komitmen nyata dari XuYuan Class
        untuk menghargai dan melindungi setiap data atau informasi pribadi
        Pengguna situs
        <a href="https://www.xuyuanchinese.com">www.xuyuanchinese.com</a>,
        situs-situs turunannya, serta aplikasi XuYuan Little Sunshine.
      </p>
      <p>
        Dalam menjalankan dan mengelola Platform ini, kami menerapkan Kebijakan
        Privasi untuk menetapkan tata cara perlindungan dan penggunaan informasi
        yang Anda berikan ketika menggunakan layanan yang tersedia dalam
        Platform ("Pengguna").
      </p>
      <p>
        Kami berkomitmen untuk memastikan bahwa privasi Pengguna akan
        dilindungi. Bila Kami meminta Pengguna untuk memberikan informasi
        tertentu yang dapat diidentifikasi ketika menggunakan Platform ini, maka
        informasi tersebut itu hanya akan digunakan sesuai dengan pernyataan
        dalam Ketentuan dan Kebijakan Privasi ini.
      </p>
      <p>
        Kebijakan Privasi ini meliputi proses perolehan, pengelolaan,
        penggunaan, perlindungan yang berhubungan dengan informasi dan data
        pribadi Pengguna berdasarkan aturan perundang-undangan yang berlaku di
        wilayah Negara Kesatuan Republik Indonesia dan standar keamanan
        informasi yang bersifat global. Dalam proses peningkatan layanan kami,
        Ketentuan dan Kebijakan Privasi bisa berubah atau diperbaharui
        sewaktu-waktu baik dengan atau tanpa melalui pemberitahuan dan/atau
        pengumuman terlebih dahulu.
      </p>
      <p>
        Dengan mengakses dan menggunakan layanan pada Platform, Pengguna
        dianggap telah membaca, memahami, dan memberikan persetujuan kepada Kami
        atas pengumpulan, pemrosesan, pengungkapan, dan penggunaan informasi dan
        juga data pribadi Pengguna.
      </p>
      <h2 class="primary--text">PEROLEHAN DATA PRIBADI</h2>
      <p>
        Untuk menunjang layanan yang disediakan Platform, kami akan melakukan
        pengambilan data pribadi dan informasi pribadi lainnya termasuk dan
        tidak terbatas kepada nama dan email, catatan riwayat yang berhubungan
        dengan IP Address, tipe perangkat, system operasi, dan informasi lainnya
        yang dapat diperlukan.
      </p>
      <h2 class="primary--text">REKAMAN SUARA</h2>
      <p>
        Platform melakukan rekaman suara yang hanya tersimpan di perangkat
        pengguna dan akan dihapus saat aplikasi dihapus.
      </p>
    </v-container>
  </v-container>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutHome from '@layouts/Home.vue'
export default {
  name: 'AboutUs',
  components: {
    Head,
  },
  layout: LayoutHome,
  data() {
    return {
      timelines: [
        {
          color: 'cyan',
          year: '2018',
          title: "Company's Start",
          content:
            'XuYuan Class was founded in 2018. XuYuan Class is starting to come with an offline course system in West Surabaya, Indonesia',
        },
        {
          color: 'green',
          year: '2020',
          title: 'System Update and Native Teacher',
          content:
            'Due to the pandemic in 2019, we changed our teaching system to online and began to expand outside Surabaya. <br />In 2020, XuYuan Class added more native teachers due to the increasing demand for onilne teaching',
        },
        {
          color: 'pink',
          year: '2021',
          title: 'Become an Official Company in China',
          content:
            'In 2021, XuYuan Class was officially registered as an official company in China and now teaching more than 3000 hours per month',
        },
        {
          color: 'amber',
          year: '2022',
          title: 'Launch Website and Learning App',
          content:
            'In mid 2022, XuYuan Class will launch official website and learning app to help kindergarten students learn in a more fun ways',
        },
      ],
    }
  },
}
</script>
